import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Input, Popconfirm, Table } from 'antd';
import NewStyleInput from './NewStyleInput';
import { styleLocks } from '../../../shared/theme/styleList';
import Tooltip from '../../common/Tooltip';
import { useState } from 'react';
import './tableConfig.css';

/**
 * Colonne de gauche des onglets de styles de box partagées (Volet, Carte
 * info) : créer, renommer, dupliquer, supprimer, sélectionner.
 *
 * Le style d'id 0 et ceux qui viennent d'une section liée (`fromTmp`) ne se
 * renomment ni ne se suppriment, comme dans les autres onglets de styles.
 */
const iconStyle = { margin: '.5rem', fontSize: '1.5em' };

const BoxStyleList = ({
  title,
  styles,
  selectedId,
  onSelect,
  onAdd,
  onCopy,
  onRename,
  onRemove,
}) => {
  const [editingId, setEditingId] = useState(null);
  const [editedName, setEditedName] = useState('');

  const submitRename = (id, value) => {
    onRename(id, value);
    setEditingId(null);
    setEditedName('');
  };

  const columns = [
    { title: 'Actions', dataIndex: 'actions', key: 'actions', width: 120 },
    {
      title: 'Style',
      dataIndex: 'style',
      key: 'style',
      onCell: (element) => ({ onClick: () => onSelect(element.id) }),
    },
  ];

  const dataSource = styles.map((element) => {
    const locks = styleLocks(element);
    const cantEdit = locks.remove;
    return {
      key: `boxStyle-${element.id}`,
      id: element.id,
      style: editingId === element.id ? (
        <Input
          value={editedName}
          style={{ width: '60%' }}
          onChange={(e) => setEditedName(e.target.value)}
          onPressEnter={(e) => {
            if (!cantEdit && e.target.value.length > 0) submitRename(element.id, e.target.value);
          }}
          onBlur={(e) => {
            if (!cantEdit && e.target.value.length > 0) submitRename(element.id, e.target.value);
          }}
        />
      ) : element.name,
      actions: (
        <div>
          <Tooltip placement="bottom" mouseLeaveDelay="0" title="Renommer">
            <FontAwesomeIcon
              icon={icon({ name: 'edit', style: 'light' })}
              style={{ ...iconStyle, color: cantEdit ? 'lightgray' : 'black' }}
              onClick={cantEdit ? null : () => {
                setEditingId(element.id);
                setEditedName(element.name);
              }}
            />
          </Tooltip>
          <Tooltip placement="bottom" mouseLeaveDelay="0" title="Dupliquer">
            <FontAwesomeIcon
              icon={icon({ name: 'copy', style: 'light' })}
              style={{ ...iconStyle, color: locks.copy ? 'lightgray' : 'black' }}
              onClick={locks.copy ? null : () => onCopy(element.id)}
            />
          </Tooltip>
          <Tooltip placement="bottom" mouseLeaveDelay="0" title="Supprimer">
            {cantEdit ? (
              <FontAwesomeIcon
                icon={icon({ name: 'trash', style: 'light' })}
                style={{ ...iconStyle, color: 'lightgray' }}
              />
            ) : (
              <Popconfirm
                title="Voulez vous vraiment supprimer ce style ?"
                onConfirm={() => onRemove(element.id)}
                okText="Oui"
                cancelText="Non"
              >
                <FontAwesomeIcon
                  icon={icon({ name: 'trash', style: 'light' })}
                  style={{ ...iconStyle, color: 'red' }}
                />
              </Popconfirm>
            )}
          </Tooltip>
        </div>
      ),
    };
  });

  return (
    <div style={{ textAlign: 'center', width: '40%' }}>
      <h5>{title}</h5>
      <NewStyleInput onAdd={onAdd} />
      <Table
        columns={columns}
        dataSource={dataSource}
        rowClassName={(record) => (record.id === selectedId ? 'tableSelectedRow' : '')}
        pagination={false}
      />
    </div>
  );
};

export default BoxStyleList;
